import { render, staticRenderFns } from "./EditPurchasedLicenseList.vue?vue&type=template&id=052b6c55&scoped=true"
import script from "./EditPurchasedLicenseList.vue?vue&type=script&lang=js"
export * from "./EditPurchasedLicenseList.vue?vue&type=script&lang=js"
import style0 from "./EditPurchasedLicenseList.vue?vue&type=style&index=0&id=052b6c55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b6c55",
  null
  
)

export default component.exports